import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הלופ",
    opening: localizedGenderNode(
      [
      "היום אני לא פותר/ת. אני רק מזהה: זה אותו ויכוח, אותו מסלול."
    ],
      [
      "היום אני לא פותר/ת. אני רק מזהה: זה אותו ויכוח, אותו מסלול."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת.",
      "בלב: “זה לופ. לא אני.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת.",
      "בלב: “זה לופ. לא אני.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה — בשבילי\nמה הנושא שחוזר שוב ושוב?",
      "מה המשפט הראשון שמדליק את זה בדרך כלל?",
      "איך זה בדרך כלל נגמר?"
    ],
      [
      "כתיבה — בשבילי\nמה הנושא שחוזר שוב ושוב?",
      "מה המשפט הראשון שמדליק את זה בדרך כלל?",
      "איך זה בדרך כלל נגמר?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כשאני מזהה לופ — כבר יש לי כוח."
    ],
      [
      "סגירה",
      "כשאני מזהה לופ — כבר יש לי כוח."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: “זה לופ.” + נשימה. בלי להמשיך את הוויכוח בראש.",
      "פעם אחת היום: “זה לופ.” + נשימה. בלי להמשיך את הוויכוח בראש."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "טריגר ראשון: מה מפעיל אותי",
    opening: localizedGenderNode(
      [
      "היום אני רואה מה מפעיל אותי לפני שאני מגיב/ה."
    ],
      [
      "היום אני רואה מה מפעיל אותי לפני שאני מגיב/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הטריגר שמדליק אותי? (מילה/טון/מבט/זמן/עייפות)",
      "מה אני מרגיש/ה בשנייה הראשונה? (כעס/עלבון/פחד/בושה)",
      "מה אני בוחר/ת/ה באותו רגע ולא יודע/ת להגיד?"
    ],
      [
      "כתיבה\nמה הטריגר שמדליק אותי? (מילה/טון/מבט/זמן/עייפות)",
      "מה אני מרגיש/ה בשנייה הראשונה? (כעס/עלבון/פחד/בושה)",
      "מה אני בוחר/ת/ה באותו רגע ולא יודע/ת להגיד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לפעמים הוויכוח הוא רק עטיפה לצורך."
    ],
      [
      "סגירה",
      "לפעמים הוויכוח הוא רק עטיפה לצורך."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה הטריגר: יד על החזה + נשימה אחת לפני מילה.",
      "כשעולה הטריגר: יד על החזה + נשימה אחת לפני מילה."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מה אני באמת מנסה להשיג בוויכוח",
    opening: localizedGenderNode(
      [
      "היום אני שואל/ת: מה אני באמת רוצה — מתחת לצעקה."
    ],
      [
      "היום אני שואל/ת: מה אני באמת רוצה — מתחת לצעקה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nכשאני נכנס/ת לוויכוח הזה — מה אני מנסה להשיג?",
      "האם אני מחפש/ת צדק, קרבה, הכרה, ביטחון?",
      "איזו בקשה אחת פשוטה מסתתרת מתחת לזה?"
    ],
      [
      "כתיבה\nכשאני נכנס/ת לוויכוח הזה — מה אני מנסה להשיג?",
      "האם אני מחפש/ת צדק, קרבה, הכרה, ביטחון?",
      "איזו בקשה אחת פשוטה מסתתרת מתחת לזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בקשה ברורה עדיפה על מלחמה."
    ],
      [
      "סגירה",
      "בקשה ברורה עדיפה על מלחמה."
    ]
    ),
    action: localizedGenderNode(
      "אני מנסח/ת לעצמי בקשה אחת קצרה (רק לעצמי).",
      "אני מנסח/ת לעצמי בקשה אחת קצרה (רק לעצמי)."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "מה הצד השני אולי שומע ממני",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך זה נשמע מהצד השני."
    ],
      [
      "היום אני בודק/ת איך זה נשמע מהצד השני."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “כוונה טובה יכולה להישמע כמו מתקפה.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “כוונה טובה יכולה להישמע כמו מתקפה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nכשאני אומר/ת את המשפטים שלי — איך זה יכול להישמע?",
      "איזה משפט אחד שלי נשמע כמו האשמה?",
      "איך אפשר להגיד אותו כ”אני מרגיש/ה…” במקום “את/ה תמיד…”?"
    ],
      [
      "כתיבה\nכשאני אומר/ת את המשפטים שלי — איך זה יכול להישמע?",
      "איזה משפט אחד שלי נשמע כמו האשמה?",
      "איך אפשר להגיד אותו כ”אני מרגיש/ה…” במקום “את/ה תמיד…”?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "שפה רכה לא אומרת שאני מוותר/ת. היא אומרת שאני חכם/ה."
    ],
      [
      "סגירה",
      "שפה רכה לא אומרת שאני מוותר/ת. היא אומרת שאני חכם/ה."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום אני מחליף/ה “את/ה…” ל-“אני…”",
      "פעם אחת היום אני מחליף/ה “את/ה…” ל-“אני…”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "נקודת האל-חזור",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מתי הוויכוח כבר לא על הנושא."
    ],
      [
      "היום אני מזהה מתי הוויכוח כבר לא על הנושא."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הסימן שהגענו לנקודת האל-חזור? (טון/צרחות/זלזול/ניתוק)",
      "מה אני עושה שם בדרך כלל?",
      "מה הייתי רוצה לעשות במקום? (עצירה/הפסקה/מים/מרחק)"
    ],
      [
      "כתיבה\nמה הסימן שהגענו לנקודת האל-חזור? (טון/צרחות/זלזול/ניתוק)",
      "מה אני עושה שם בדרך כלל?",
      "מה הייתי רוצה לעשות במקום? (עצירה/הפסקה/מים/מרחק)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לצאת מהלופ בזמן זו בגרות."
    ],
      [
      "סגירה",
      "לצאת מהלופ בזמן זו בגרות."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת “מילת עצירה” לעצמי: “רגע.” ואז נשימה.",
      "אני בוחר/ת “מילת עצירה” לעצמי: “רגע.” ואז נשימה."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "הפסקה מכבדת (לא נטישה)",
    opening: localizedGenderNode(
      [
      "היום אני לומד/ת לקחת הפסקה בלי לפגוע."
    ],
      [
      "היום אני לומד/ת לקחת הפסקה בלי לפגוע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה מפחיד אותי בלהפסיק ויכוח באמצע?",
      "איך נשמעת הפסקה מכבדת במשפט אחד?",
      "כמה זמן הפסקה אני בוחר/ת/ה כדי לחזור רגוע/ה?"
    ],
      [
      "כתיבה\nמה מפחיד אותי בלהפסיק ויכוח באמצע?",
      "איך נשמעת הפסקה מכבדת במשפט אחד?",
      "כמה זמן הפסקה אני בוחר/ת/ה כדי לחזור רגוע/ה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הפסקה היא הגנה על הקשר, לא בריחה."
    ],
      [
      "סגירה",
      "הפסקה היא הגנה על הקשר, לא בריחה."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת לעצמי “משפט הפסקה” אחד קבוע.",
      "אני כותב/ת לעצמי “משפט הפסקה” אחד קבוע."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "מה אני מביא/ה מהעבר לתוך הוויכוח",
    opening: localizedGenderNode(
      [
      "היום אני רואה מה מופעל בי מעבר להווה."
    ],
      [
      "היום אני רואה מה מופעל בי מעבר להווה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמתי בחיים הרגשתי ככה בעבר? (לא להעמיק — רק לזהות)",
      "מה הפצע שמופעל בי בלופ הזה?",
      "מה הייתי בוחר/ת/ה אז ולא קיבלתי?"
    ],
      [
      "כתיבה\nמתי בחיים הרגשתי ככה בעבר? (לא להעמיק — רק לזהות)",
      "מה הפצע שמופעל בי בלופ הזה?",
      "מה הייתי בוחר/ת/ה אז ולא קיבלתי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לפעמים אנחנו רבים בהווה עם כאב ישן."
    ],
      [
      "סגירה",
      "לפעמים אנחנו רבים בהווה עם כאב ישן."
    ]
    ),
    action: localizedGenderNode(
      "כשזה עולה: “זה כאב ישן שמבקש ביטחון.”",
      "כשזה עולה: “זה כאב ישן שמבקש ביטחון.”"
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "להפריד בין בעיה לבין אופי",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק/ה להפוך את הוויכוח ל”מי אתה”."
    ],
      [
      "היום אני מפסיק/ה להפוך את הוויכוח ל”מי אתה”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיזה משפטים הופכים את זה לאישי? (“אתה כזה”, “את תמיד ככה”)",
      "איך אני יכול/ה לדבר על התנהגות בלי לתקוף זהות?",
      "מה אני באמת רוצה לשנות בפועל?"
    ],
      [
      "כתיבה\nאיזה משפטים הופכים את זה לאישי? (“אתה כזה”, “את תמיד ככה”)",
      "איך אני יכול/ה לדבר על התנהגות בלי לתקוף זהות?",
      "מה אני באמת רוצה לשנות בפועל?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "התנהגות אפשר לשנות. השפלה הורסת."
    ],
      [
      "סגירה",
      "התנהגות אפשר לשנות. השפלה הורסת."
    ]
    ),
    action: localizedGenderNode(
      "אני מתאמן/ת על משפט: “אני מדבר/ת על מה שקרה, לא על מי שאת/ה.”",
      "אני מתאמן/ת על משפט: “אני מדבר/ת על מה שקרה, לא על מי שאת/ה.”"
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "מה הגבול שלי בתוך ויכוח",
    opening: localizedGenderNode(
      [
      "היום אני מגדיר/ה מה לא מקובל עליי בזמן ריב."
    ],
      [
      "היום אני מגדיר/ה מה לא מקובל עליי בזמן ריב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הגבול שלי בוויכוח? (צעקות/קללות/ניתוק/איומים)",
      "מה אני עושה כשעוברים אותו?",
      "מה אני מוכן/ה לעשות כדי לשמור על הגבול?"
    ],
      [
      "כתיבה\nמה הגבול שלי בוויכוח? (צעקות/קללות/ניתוק/איומים)",
      "מה אני עושה כשעוברים אותו?",
      "מה אני מוכן/ה לעשות כדי לשמור על הגבול?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גבול הוא לא עונש. הוא שמירה."
    ],
      [
      "סגירה",
      "גבול הוא לא עונש. הוא שמירה."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת גבול אחד ברור במשפט אחד.",
      "אני כותב/ת גבול אחד ברור במשפט אחד."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה אחת במקום רשימה",
    opening: localizedGenderNode(
      [
      "היום אני מבקש/ת דבר אחד ברור — לא עשרה דברים."
    ],
      [
      "היום אני מבקש/ת דבר אחד ברור — לא עשרה דברים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הבקשה הכי חשובה לי בתוך הלופ הזה?",
      "איך זה נשמע קצר, ברור, בלי האשמה?",
      "מה אני מוכן/ה לתת בתמורה? (שפה/זמן/מאמץ)"
    ],
      [
      "כתיבה\nמה הבקשה הכי חשובה לי בתוך הלופ הזה?",
      "איך זה נשמע קצר, ברור, בלי האשמה?",
      "מה אני מוכן/ה לתת בתמורה? (שפה/זמן/מאמץ)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בקשה אחת אמיתית יוצרת סיכוי לתנועה."
    ],
      [
      "סגירה",
      "בקשה אחת אמיתית יוצרת סיכוי לתנועה."
    ]
    ),
    action: localizedGenderNode(
      "אני מתרגל/ת להגיד את הבקשה בקול לעצמי פעם אחת.",
      "אני מתרגל/ת להגיד את הבקשה בקול לעצמי פעם אחת."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "תיקון אחרי ריב (Repair)",
    opening: localizedGenderNode(
      [
      "היום אני לומד/ת איך מתקנים בלי למחוק."
    ],
      [
      "היום אני לומד/ת איך מתקנים בלי למחוק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הדבר הכי פוגע שעשיתי/אמרתי בלופ הזה?",
      "איך אני יכול/ה לקחת אחריות בלי להצדיק?",
      "איזה משפט תיקון אחד הייתי רוצה לשמוע?"
    ],
      [
      "כתיבה\nמה הדבר הכי פוגע שעשיתי/אמרתי בלופ הזה?",
      "איך אני יכול/ה לקחת אחריות בלי להצדיק?",
      "איזה משפט תיקון אחד הייתי רוצה לשמוע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "תיקון בונה אמון."
    ],
      [
      "סגירה",
      "תיקון בונה אמון."
    ]
    ),
    action: localizedGenderNode(
      "אני מנסח/ת “משפט תיקון” אחד קצר.",
      "אני מנסח/ת “משפט תיקון” אחד קצר."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לבחור זמן נכון לשיחה",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק/ה לנסות לפתור כשאנחנו גמורים."
    ],
      [
      "היום אני מפסיק/ה לנסות לפתור כשאנחנו גמורים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמתי אנחנו בדרך כלל רבים? (לילה/עייפות/לחץ)",
      "מתי יותר סיכוי לשיחה טובה?",
      "איך אני יכול/ה להציע זמן אחר בלי להישמע מתחמק/ת?"
    ],
      [
      "כתיבה\nמתי אנחנו בדרך כלל רבים? (לילה/עייפות/לחץ)",
      "מתי יותר סיכוי לשיחה טובה?",
      "איך אני יכול/ה להציע זמן אחר בלי להישמע מתחמק/ת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "תזמון נכון הוא חצי כיוון."
    ],
      [
      "סגירה",
      "תזמון נכון הוא חצי כיוון."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת “חלון שיחה” אחד אפשרי לשבוע.",
      "אני בוחר/ת “חלון שיחה” אחד אפשרי לשבוע."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "מה אנחנו באמת צריכים כזוג",
    opening: localizedGenderNode(
      [
      "היום אני מסתכל/ת על הצורך הזוגי שמתחת ללופ."
    ],
      [
      "היום אני מסתכל/ת על הצורך הזוגי שמתחת ללופ."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה חסר לנו שמדליק את הלופ? (ביטחון/הקשבה/זמן/כבוד)",
      "מה כן עובד בינינו כשזה טוב?",
      "איזה שינוי קטן יכול לשפר 10%?"
    ],
      [
      "כתיבה\nמה חסר לנו שמדליק את הלופ? (ביטחון/הקשבה/זמן/כבוד)",
      "מה כן עובד בינינו כשזה טוב?",
      "איזה שינוי קטן יכול לשפר 10%?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לא רוצהים מהפכה. לפעמים מספיק 10%."
    ],
      [
      "סגירה",
      "לא רוצהים מהפכה. לפעמים מספיק 10%."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת שינוי קטן אחד לשבוע.",
      "אני בוחר/ת שינוי קטן אחד לשבוע."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה: משפט חזרה ללופ הבא",
    opening: localizedGenderNode(
      [
      "היום אני יוצא/ת עם משפט שמחזיר אותי לעצמי בזמן אמת."
    ],
      [
      "היום אני יוצא/ת עם משפט שמחזיר אותי לעצמי בזמן אמת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה למדתי על הלופ הזה?",
      "מה הסימן הכי מוקדם שאני נכנס/ת אליו?",
      "משפט חזרה ל”רגע לפני” (קצר, בכיס):"
    ],
      [
      "כתיבה\nמה למדתי על הלופ הזה?",
      "מה הסימן הכי מוקדם שאני נכנס/ת אליו?",
      "משפט חזרה ל”רגע לפני” (קצר, בכיס):"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא רוצה/ת לנצח בוויכוח כדי להיות בטוח/ה.",
      "אני רוצה קשר שיש בו כבוד — גם כשכואב.",
      "ואני מתחיל/ה בזה: עצירה אחת. נשימה אחת. מילה אחת פחות."
    ],
      [
      "סגירה סופית למסע",
      "אני לא רוצה/ת לנצח בוויכוח כדי להיות בטוח/ה.",
      "אני רוצה קשר שיש בו כבוד — גם כשכואב.",
      "ואני מתחיל/ה בזה: עצירה אחת. נשימה אחת. מילה אחת פחות."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: אני בוחר/ת שקט במקום תגובה.",
      "פעם אחת היום: אני בוחר/ת שקט במקום תגובה."
    ),
  },
].map(buildNormalizedDay);

export const repeatingConflictsInRelationshipBlueprintHe = buildNormalizedPilotBlueprint({
  id: "repeating_conflicts_in_relationship_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "repeating_conflicts_in_relationship",
  category: "general",
  journeyName: {
    he: "מריבות חוזרות (אותו סיפור שוב ושוב)",
    en: "Repeating Conflicts (The Same Story Again and Again)",
    es: "Conflictos repetidos (La misma historia una y otra vez)",
  },
  days,
});

export default repeatingConflictsInRelationshipBlueprintHe;
